export default {
    title: 'Accident Intake',
    heading: 'Accident Intake',
    menu_label: 'Intake',
    submit_success: 'Intake submitted successfully.',
    submit_error: 'Unable to submit intake. Check the Network tab for the request payload.',
    success: {
        heading: 'Intake submitted',
        message:
            "Saved to MedMatch's intake database. Copy the summary below into the chart, an email, or an LLM prompt to draft the H&P — this is the same structured data, just rendered readable for now.",
        copy: 'Copy summary to clipboard',
        copied: 'Copied',
        download: 'Download as PDF',
        done: 'Done',
    },

    breadcrumbs: {
        intake: 'Intake',
        about_you: 'About You',
        what_happened: 'What Happened',
        how_you_felt: 'How You Felt Afterward',
        symptoms_today: 'Your Symptoms Today',
        health_screening: 'Health Screening',
        treatment_received: "Treatment You've Received",
        treating_providers: 'Treating Providers',
        tests_imaging: 'Tests & Imaging',
        previous_injuries: 'Previous Injuries',
        medical_surgical: 'Medical & Surgical History',
        medications_allergies: 'Medications & Allergies',
        work_information: 'Work Information',
        social_family: 'Social & Family History',
        daily_activities: 'Daily Activities',
        health_questions: 'Health Questions',
        review_submit: 'Review & Submit',
        confirm_submit: 'Confirm & Submit',
    },

    step1: {
        progress: 'Step 1 of 17 — About You',
        heading: 'About You',
        description: 'A few quick questions before we get into your injury.',
    },

    step2: {
        progress: 'Step 2 of 17 — What Happened',
        heading: 'What Happened',
        description: 'Tell us about the incident that caused the injuries you’re being seen for.',
    },

    step3: {
        progress: 'Step 3 of 17 — How You Felt Afterward',
        heading: 'How You Felt Afterward',
        description: 'Symptoms right after the incident, and the care you received.',
    },

    step4: {
        progress: 'Step 4 of 17 — Your Symptoms Today',
        heading: 'Your Symptoms Today',
        description:
            'List every problem you’re having because of this incident. Add the one bothering you most first — the order below is used as priority.',
    },

    step5: {
        progress: 'Step 5 of 17 — Health Screening',
        heading: 'Health Screening Questions',
        description: 'Since this injury, have you experienced any of the following?',
    },

    step6: {
        progress: "Step 6 of 17 — Treatment You've Received",
        heading: "Treatment You've Received",
        description:
            "Since the incident, list every treatment you've had for these injuries — ER visits, PT, chiropractic, injections, surgery, medications, etc.",
    },

    step7: {
        progress: 'Step 7 of 17 — Treating Providers',
        heading: 'Treating Providers',
        description: 'Which doctors or healthcare professionals have treated you for injuries from this incident?',
    },

    step8: {
        progress: 'Step 8 of 17 — Tests & Imaging',
        heading: 'Tests & Imaging',
        description: 'What tests or imaging have you had because of this incident?',
    },

    step9: {
        progress: 'Step 9 of 17 — Previous Injuries',
        heading: 'Previous Injuries',
        description: 'Before this incident, had you ever had any of the following?',
    },

    step10: {
        progress: 'Step 10 of 17 — Medical & Surgical History',
        heading: 'Medical & Surgical History',
        description: '',
    },

    step11: {
        progress: 'Step 11 of 17 — Medications & Allergies',
        heading: 'Medications & Allergies',
        description: '',
    },

    step12: {
        progress: 'Step 12 of 17 — Work Information',
        heading: 'Work Information',
        description: '',
    },

    step13: {
        progress: 'Step 13 of 17 — Social & Family History',
        heading: 'Social & Family History',
        description: '',
    },

    step14: {
        progress: 'Step 14 of 17 — Daily Activities',
        heading: 'Daily Activities',
        description: 'Compared with before the incident, how are these activities affected?',
    },

    step15: {
        progress: 'Step 15 of 17 — Health Questions',
        heading: 'Health Questions',
        description:
            'A general review of your overall health. Items already reported as symptoms are pre-marked — confirm or change as needed.',
    },

    step16: {
        progress: 'Step 16 of 17 — Review & Submit',
        heading: 'Review & Submit',
        description: 'Please check everything below before submitting.',
    },

    step17: {
        progress: 'Step 17 of 17 — Confirm & Submit',
        heading: 'Confirm & Submit',
        description: '',
    },
}
